import { useEffect, useState } from 'react';

import { Content, Header, Page } from '@backstage/core-components';
import {
  ProfileInfo,
  configApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import {
  HomePageRecentlyVisited,
  HomePageStarredEntities,
  HomePageToolkit,
  HomePageTopVisited,
} from '@backstage/plugin-home';
import { HomePageSearchBar } from '@backstage/plugin-search';
import { Box, Grid, Typography } from '@material-ui/core';
import { Navigate } from 'react-router-dom';

import useStyles from './HomePage.styles';
import { ToolKitItem, resolveLinksForUser } from './utils/toolkitUtils.tsx';
import { useHomepageToolkit } from './utils/useHomepageToolkit.ts';

export const HomePage = () => {
  const identity = useApi(identityApiRef);
  const config = useApi(configApiRef);
  const getToolkit = useHomepageToolkit();
  const classes = useStyles();

  const [user, setUser] = useState<ProfileInfo>();
  const [toolKits, setToolKits] = useState<ToolKitItem[]>();

  useEffect(() => {
    identity.getProfileInfo().then(d => {
      setUser(d);
    });

    getToolkit().then(d => {
      identity.getBackstageIdentity().then(userGroups => {
        setToolKits(resolveLinksForUser(userGroups.ownershipEntityRefs, d));
      });
    });
  }, [getToolkit, identity]);

  if (!config.getOptionalBoolean('configFeatureFlags.showHomeDashboard')) {
    return <Navigate to="/catalog" replace />;
  }

  return (
    <Page themeId="tool">
      <Header subtitle={user?.displayName} title="Welcome" />
      <Content>
        <Box className={classes.titleContainer}>
          <Typography variant="h2" component="h1" align="center">
            Backstage
          </Typography>
        </Box>

        <Box className={classes.searchContainer} data-testid="home-page-search">
          <Box className={classes.searchBox}>
            <HomePageSearchBar />
          </Box>
        </Box>

        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={6} data-test="TopVisited">
            <HomePageTopVisited />
          </Grid>
          <Grid item xs={12} md={6} data-test="RecentlyVisited">
            <HomePageRecentlyVisited />
          </Grid>
          <Grid item xs={12} md={6} data-test="StarredEntities">
            <HomePageStarredEntities />
          </Grid>
          <Grid item xs={12} md={6}>
            {toolKits && <HomePageToolkit tools={toolKits} />}
          </Grid>
        </Grid>
      </Content>
    </Page>
  );
};
